// extracted by mini-css-extract-plugin
export default {"appAbout":"About_appAbout__o4Jk4","formula":"About_formula__IxeHt","hidden":"About_hidden__Uafoe","notation":"About_notation__ph0IS","notationSymbol":"About_notationSymbol__GSKF1"};